import BaseComponent from 'components/pages/OutgoAggregation';
import getOutgoAggregations from 'domains/api/outgo_aggregations';
import { resetCurrentUser } from 'domains/current_user';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import * as Types from 'types';

type SearchParams = {
  kind: Types.OutgoAggregateResultKind | null;
  beginDate: string | null;
  endDate: string | null;
};

const OutgoAggregation: React.FC = () => {
  const navigate = useNavigate();

  const [searchParams, setSearchParams] = useState<SearchParams>({
    kind: 'all',
    beginDate: '',
    endDate: '',
  });
  const onSubmit = (
    kind: string | null,
    beginDate: Date | null,
    endDate: Date | null,
  ) => {
    console.log(
      `onSubmit kind:${kind || 'none'} beginDate:${
        beginDate?.toLocaleString('ja-JP') || 'none'
      } endDate:${endDate?.toLocaleString('ja-JP') || 'none'}`,
      setSearchParams({
        kind: kind ? Types.convertNumberToOutgoKind(parseInt(kind, 10)) : null,
        beginDate: beginDate?.toLocaleString('ja-JP') || null,
        endDate: endDate?.toLocaleString('ja-JP') || null,
      }),
    );
  };

  const [outgoAggregateResults, setOutgoAggregateResults] = useState<
    Types.OutgoAggregateResult[]
  >([]);
  const [isLoading, setIsLoading] = useState(false);
  useEffect(() => {
    setIsLoading(true);
    void getOutgoAggregations(
      searchParams.kind || '',
      searchParams.beginDate || '',
      searchParams.endDate || '',
    )
      .then((response) => {
        setOutgoAggregateResults(response.outgo_aggregate_results);
        setIsLoading(false);
      })
      .catch(() => {
        resetCurrentUser();
        navigate('/signIn');
      });
  }, [navigate, searchParams]);

  return (
    <BaseComponent
      isLoading={isLoading}
      onSubmit={onSubmit}
      outgoAggregateResults={outgoAggregateResults}
      resultKind={searchParams.kind || 'all'}
    />
  );
};

export default OutgoAggregation;
